var map = {
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./assets/fonts/OFL.txt": 7862,
	"./assets/fonts/README.txt": 58235,
	"./assets/fonts/RedHatText-Italic-VariableFont_wght.ttf": 42924,
	"./assets/fonts/RedHatText-VariableFont_wght.ttf": 12957,
	"./assets/fonts/static/RedHatText-Bold.ttf": 56031,
	"./assets/fonts/static/RedHatText-Regular.ttf": 27782,
	"./assets/fonts/static/RedHatText-SemiBold.ttf": 68869,
	"./assets/images/favicon-32x32.png": 574,
	"./assets/images/icon-add-to-cart.svg": 20019,
	"./assets/images/icon-carbon-neutral.svg": 77332,
	"./assets/images/icon-decrement-quantity.svg": 9034,
	"./assets/images/icon-increment-quantity.svg": 27578,
	"./assets/images/icon-order-confirmed.svg": 65355,
	"./assets/images/icon-remove-item.svg": 54087,
	"./assets/images/illustration-empty-cart.svg": 74888,
	"./assets/images/image-baklava-desktop.jpg": 33924,
	"./assets/images/image-baklava-mobile.jpg": 90104,
	"./assets/images/image-baklava-tablet.jpg": 22214,
	"./assets/images/image-baklava-thumbnail.jpg": 94084,
	"./assets/images/image-brownie-desktop.jpg": 68906,
	"./assets/images/image-brownie-mobile.jpg": 15366,
	"./assets/images/image-brownie-tablet.jpg": 25504,
	"./assets/images/image-brownie-thumbnail.jpg": 98358,
	"./assets/images/image-cake-desktop.jpg": 57444,
	"./assets/images/image-cake-mobile.jpg": 13848,
	"./assets/images/image-cake-tablet.jpg": 45958,
	"./assets/images/image-cake-thumbnail.jpg": 228,
	"./assets/images/image-creme-brulee-desktop.jpg": 45934,
	"./assets/images/image-creme-brulee-mobile.jpg": 94514,
	"./assets/images/image-creme-brulee-tablet.jpg": 26412,
	"./assets/images/image-creme-brulee-thumbnail.jpg": 57250,
	"./assets/images/image-macaron-desktop.jpg": 41659,
	"./assets/images/image-macaron-mobile.jpg": 89909,
	"./assets/images/image-macaron-tablet.jpg": 95851,
	"./assets/images/image-macaron-thumbnail.jpg": 95631,
	"./assets/images/image-meringue-desktop.jpg": 71182,
	"./assets/images/image-meringue-mobile.jpg": 15250,
	"./assets/images/image-meringue-tablet.jpg": 34764,
	"./assets/images/image-meringue-thumbnail.jpg": 58498,
	"./assets/images/image-panna-cotta-desktop.jpg": 32770,
	"./assets/images/image-panna-cotta-mobile.jpg": 6670,
	"./assets/images/image-panna-cotta-tablet.jpg": 12408,
	"./assets/images/image-panna-cotta-thumbnail.jpg": 59678,
	"./assets/images/image-tiramisu-desktop.jpg": 40504,
	"./assets/images/image-tiramisu-mobile.jpg": 15460,
	"./assets/images/image-tiramisu-tablet.jpg": 48818,
	"./assets/images/image-tiramisu-thumbnail.jpg": 92272,
	"./assets/images/image-waffle-desktop.jpg": 96053,
	"./assets/images/image-waffle-mobile.jpg": 54039,
	"./assets/images/image-waffle-tablet.jpg": 7241,
	"./assets/images/image-waffle-thumbnail.jpg": 23077,
	"./components/Cart": 93500,
	"./components/Cart.css": 4818,
	"./components/Cart.js": 93500,
	"./components/CartItem": 1699,
	"./components/CartItem.css": 72371,
	"./components/CartItem.js": 1699,
	"./components/FoodGrid": 82601,
	"./components/FoodGrid.css": 95076,
	"./components/FoodGrid.js": 82601,
	"./components/FoodItem": 43166,
	"./components/FoodItem.css": 58513,
	"./components/FoodItem.js": 43166,
	"./components/ModalItem": 11967,
	"./components/ModalItem.css": 92860,
	"./components/ModalItem.js": 11967,
	"./components/OrderModal": 89969,
	"./components/OrderModal.css": 16027,
	"./components/OrderModal.js": 89969,
	"./data": 77957,
	"./data.json": 77957,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;